import * as React from "react";

import { Tooltips, Flipper } from ".";
import type { FlipData } from ".";

// Workplace Ideas Flip Imports
import fridge from "../assets/svg/fridge.svg";
import bikeRack from "../assets/svg/bikeRack.svg";
import desk from "../assets/svg/desk.svg";
import kitchenBench from "../assets/svg/kitchenBench.svg";
import meetingRoom from "../assets/svg/meetingRoom.svg";
import microwave from "../assets/svg/microwave.svg";
import noSmoking from "../assets/svg/noSmoking.svg";
import shower from "../assets/svg/shower.svg";
import vendingMachine from "../assets/svg/vendingMachine.svg";

export const WorkEnvironment: React.FC<{}> = () => {
  const workplaceIdeas: FlipData[] = [
    {
      imgSrc: fridge,
      title: "Fridge",
      description: <>Have an alcohol free fridge.</>,
    },
    {
      imgSrc: kitchenBench,
      title: "Kitchen bench",
      description: (
        <>
          If you provide your staff with snacks, skip the biscuits and chocolate
          and serve fresh fruit instead.
        </>
      ),
    },
    {
      imgSrc: desk,
      title: "Desk",
      description: (
        <>
          Try to encourage staff to get up and move around every 30 minutes,
          even if it is just to stretch. You could even introduce sit-stand work
          desks, so they can work standing up!
        </>
      ),
    },
    {
      imgSrc: meetingRoom,
      title: "Meeting room",
      description: (
        <>
          Instead of sitting down for meetings, try having a walking meeting
          instead or even just standing up.
        </>
      ),
    },
    {
      imgSrc: bikeRack,
      title: "Bike racks",
      description: (
        <>
          Bike racks are a convenient way to store bikes and encourage your
          workforce to grab a bit of exercise by cycling to work.
        </>
      ),
    },
    {
      imgSrc: shower,
      title: "Lockers, showers, changing room",
      description: (
        <>
          If people are cycling or jogging to work then you will need to have
          showers, changing room facilities and lockers for storage.
        </>
      ),
    },
    {
      imgSrc: bikeRack,
      title: "Bike pooling",
      description: (
        <>
          Having a bike on-site that everyone is free to use will provide a
          healthier option to the company car.
        </>
      ),
    },
    {
      imgSrc: vendingMachine,
      title: "Vending machines",
      description: (
        <>
          If you have a vending machine at work, make sure you pack it full of
          healthy options like dried fruits and nuts.
        </>
      ),
    },
    {
      imgSrc: microwave,
      title: "Lunch room",
      description: (
        <>
          Ensure you fit out your lunch area with kitchen utensils, a microwave,
          a sandwich press and fridge to ensure there are the facilities
          available for staff members to make their own healthy lunch.
        </>
      ),
    },
    {
      imgSrc: noSmoking,
      title: "Signage",
      description: (
        <>
          Reinforce the Smoke-free policy through signage or put up signs to
          show people the health benefits of using the stairs instead of the
          lift.
        </>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2 d-flex flex-column align-items-center">
        <h2 className="h1 text-uppercase text-center my-4">
          What does a healthy workplace look like?
        </h2>
        <p className="text-center">
          'Workplace environment' refers to the infrastructure and facilities
          provided to staff, such as kitchen utensils, showers or a pool bike.
          <Tooltips id={24} /> A supportive environment encourages healthy
          behaviours by providing employees with the opportunity to make healthy
          choices. Creating a healthier workplace doesn't have to be a huge
          challenge. There are some small things that you can do within your
          workplace that will make a big difference to the overall health and
          wellbeing of your workforce.
        </p>
        <p className="text-center">
          Your workplace environment can strongly support and reinforce your
          health-related policies, education and activities in order to make it
          easy for your staff to make healthy choices.
        </p>
        <strong className="mb-4 text-center">
          View ideas for making your workplace a healthier one.
        </strong>

        <Flipper data={workplaceIdeas} type="workplaceIdeas" />
      </div>
    </div>
  );
};
